<template>
  <div class="index-pay">
    <div
      class="title_header"
    >Number of equipment enabled this year: {{currentEquipYearNum}} , Growth rate : {{quipRate}}</div>
    <div id="index-pay-box-charts">
      <div id="myChartWorld" :style="{width: '100%', height: '100%'}"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      mapDataList: [],
      currentEquipYearNum: null,
      quipRate: null,
    }
  },
  mounted() {
    this.drawLine()
    this.getMapCount()
  },

  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      var myChartContainer = document.getElementById('myChartWorld')
      var resizeMyChartContainer = function () {
        myChartContainer.style.width = '100%' //页面一半的大小
      }
      resizeMyChartContainer()
      var myChartWorld = this.$echarts.init(myChartContainer)

      function randomData() {
        return Math.round(Math.random() * 500)
      }
      // 绘制图表
      var optionMap = {
        title: {
          //地图显示标题
          subtext: 'Global ranking of country area',
        },
        tooltip: {},
        legend: {
          orient: 'vertical',
          left: 'left',
          data: [''],
        },
        visualMap: {
          min: 0,
          max: 1000,
          left: '10%',
          top: 'bottom',
          text: ['high', 'low'],
          calculable: true,
          color: ['#158BFE', '#ffffff'],
        },
        selectedMode: 'single',
        series: [
          {
            name: '',
            type: 'map',
            mapType: 'world',
            zoom: 1.4,
            roam: true,
            itemStyle: {
              normal: {
                borderColor: 'rgba(0, 0, 0, 0.2)',
              },
              emphasis: {
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                shadowBlur: 20,
                borderWidth: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
            showLegendSymbol: true,
            label: {
              normal: {
                show: false,
              },
              emphasis: {
                show: true,
              },
            },
            data: this.mapDataList,
          },
        ],
      }

      myChartWorld.setOption(optionMap)
      window.onresize = function () {
        resizeMyChartContainer()
        myChartWorld.resize()
      }
    },
    //获取 地图设备数量
    getMapCount() {
      this.$get(`index/getCountryEquipNum`).then(({ data: res }) => {
        console.log(res.data)
        this.mapDataList = res.data.list
        this.currentEquipYearNum = res.data.currentEquipYearNum
        this.quipRate = res.data.quipRate

        this.drawLine()
      })
    },
  },
}
</script>

<style scoped>
.title_header {
    width: 100%;
    margin-top: -20px;
    display: flex;
    justify-content: space-between;
    color: #5C5C5C;
    font-size: 14px;
    float: left;
}
.index-pay {
  width: 100%;
  height: auto;
  background: #ffffff;
  border-radius: 5px;
  /* padding: 15px; */
  box-sizing: border-box;
}
.index-pay-box {
  width: 100%;
  /* height: 200px; */
  border: 1px solid #e6e6e6;
  position: relative;
  padding: 20px 15px;
  box-sizing: border-box;
}
.index-pay-box-name {
  position: absolute;
  width: 100px;
  height: 30px;
  background: #ffffff;
  display: inline-block;
  text-align: center;
  line-height: 30px;
  font-size: 13px;
  color: #000000;
  left: 25px;
  top: -15px;
}
.index-pay-box-select {
  width: 100%;
  height: 40px;
  /* background: burlywood; */
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 10px;
}
#index-pay-box-charts {
  width: 100%;
  height: 100%;
  /*background: chocolate; */
}
</style>